export enum RenderedServicesType {
    carousel = 'carousel',
    solo = 'solo',
    stack = 'stack',
    widget = 'widget',
    categoryGrid = 'categoryGrid',
    adaptiveCarousel = 'adaptiveCarousel',
    featuredService = 'featuredService',
    featuredCategoryRow = 'featuredCategoryRow',
    categoryDirectory = 'categoryDirectory',
    shelfGroup = 'shelfGroup',
    categoryHero = 'categoryHero',
    /** Centered title/subtitle chrome for category pages without a hero. */
    categoryTextHeader = 'categoryTextHeader',
    tabbedCardSlider = 'tabbedCardSlider',
    // New types (feature-flag gated)
    categoryHeader = 'categoryHeader',
    categoryHeaderWithSearch = 'categoryHeaderWithSearch',
    tabbedCardSliderV2 = 'tabbedCardSliderV2',
    carouselV2 = 'carouselV2',
    // Data-driven widget types (backend can send type: "contentAccordion" etc. instead of type: "widget", cardType: "contentAccordion")
    contentAccordion = 'contentAccordion',
    contentWithBulletList = 'contentWithBulletList',
    generalAISm = 'generalAISm',
    categoryStats = 'categoryStats',
    testimonialUgc = 'testimonialUgc',
    testimonialReviewsV2 = 'testimonialReviewsV2',
    getStartedCta = 'getStartedCta',
    faq = 'faq',
    howItWorks = 'howItWorks',
    categorySearch = 'categorySearch',
}

export enum ServiceItemCardType {
    specialist = 'specialist',
    serviceItem = 'serviceItem',
    insurance = 'insurance',
    everydayCare = 'everydayCare',
    specialistCare = 'specialistCare',
    support = 'support',
    divider = 'divider',
    testimonial = 'testimonial',
    healthHistory = 'healthHistory',

    blog = 'blog',
    clinitians = 'clinitians',
    generalAI = 'generalAI',
    // New widget types (feature-flag gated)
    categoryHeaderWithSearch = 'categoryHeaderWithSearch',
    contentAccordion = 'contentAccordion',
    contentWithBulletList = 'contentWithBulletList',
    generalAISm = 'generalAISm',
    multiVideoPlayer = 'multiVideoPlayer',
    testimonialUgc = 'testimonialUgc',
    testimonialReviewsV2 = 'testimonialReviewsV2',
    getStartedCta = 'getStartedCta',
    faq = 'faq',
    categoryStats = 'categoryStats',
    howItWorks = 'howItWorks',
    categorySearch = 'categorySearch',
    // Tabbed card slider card types
    productCard = 'productCard',
    productImageCard = 'productImageCard',
}

export enum ServiceItemCardDirection {
    column = 'column',
    row = 'row',
}

export enum ServiceItemCategory {
    medication = 'medication',
    specialty = 'specialty',
    condition = 'condition',
    visit = 'visit',
    lab = 'lab',
}
